(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

   connectedCallback() {
  this.header = document.querySelector('.section-header');
      this.isHomeOverlay = this.dataset.homeOverlay === 'true';

      // Preserve the existing always-sticky behavior.
      this.headerIsAlwaysSticky = true;
      this.header.classList.add('shopify-section-header-sticky');

      this.headerBounds = {};
      this.resizeHandler = this.handleResize.bind(this);

      this.setupStickyHeaderStack();
      this.setHeaderHeight();

      window.addEventListener('resize', this.resizeHandler);
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.resizeHandler);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    handleResize() {
      window.clearTimeout(this.resizeTimer);

      this.resizeTimer = window.setTimeout(() => {
        this.setupStickyHeaderStack();
        this.setHeaderHeight();
        this.createObserver();
      }, 80);
    }

    getHeaderGroupSectionsAbove() {
      const sections = [];
      let sibling = this.header.previousElementSibling;

      while (sibling) {
        const isHeaderGroupSection =
          sibling.classList.contains('shopify-section-group-header-group');

        if (!isHeaderGroupSection) break;

        sections.unshift(sibling);
        sibling = sibling.previousElementSibling;
      }

      return sections.filter((section) => {
        const styles = window.getComputedStyle(section);
        const rect = section.getBoundingClientRect();

        return (
          styles.display !== 'none' &&
          styles.visibility !== 'hidden' &&
          rect.height > 0
        );
      });
    }

    setupStickyHeaderStack() {
      if (!this.header) return;

      if (this.stickyTopSections) {
        this.stickyTopSections.forEach((section) => {
          section.classList.remove('styleomg-sticky-header-bar');
          section.style.removeProperty('--so-sticky-bar-top');
          section.style.removeProperty('--so-sticky-bar-z');
        });
      }

      this.stickyTopSections = this.getHeaderGroupSectionsAbove();

      let offset = 0;

      this.stickyTopSections.forEach((section, index) => {
        section.classList.add('styleomg-sticky-header-bar');
        section.style.setProperty('--so-sticky-bar-top', `${offset}px`);
        section.style.setProperty('--so-sticky-bar-z', `${70 - index}`);

        offset += section.getBoundingClientRect().height;
      });

      this.header.style.setProperty('--so-header-top-offset', `${offset}px`);
      this.style.setProperty('--so-header-top-offset', `${offset}px`);
      document.documentElement.style.setProperty(
        '--so-header-top-offset',
        `${offset}px`
      );
    }

    setHeaderHeight() {
      const height = this.offsetHeight || this.header.offsetHeight;
      const topOffset =
        Number.parseFloat(
          getComputedStyle(this.header).getPropertyValue(
            '--so-header-top-offset'
          )
        ) || 0;

      this.header.style.setProperty(
        '--so-header-own-height',
        `${height}px`
      );
      this.style.setProperty(
        '--so-header-own-height',
        `${height}px`
      );

      document.documentElement.style.setProperty(
        '--header-height',
        `${height}px`
      );
      document.documentElement.style.setProperty(
        '--header-stack-height',
        `${height + topOffset}px`
      );
    }

    disconnectedCallback() {
      this.removeEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.resizeHandler);

      if (this.stickyTopSections) {
        this.stickyTopSections.forEach((section) => {
          section.classList.remove('styleomg-sticky-header-bar');
          section.style.removeProperty('--so-sticky-bar-top');
          section.style.removeProperty('--so-sticky-bar-z');
        });
      }
    }

    createObserver() {
      const rect = this.getBoundingClientRect();
      const absoluteTop = rect.top + window.pageYOffset;

      this.headerBounds = {
        top: absoluteTop,
        bottom: absoluteTop + this.offsetHeight
      };

      requestAnimationFrame(() => this.onScroll());
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const activationPoint = this.isHomeOverlay ? 8 : this.headerBounds.bottom;
      const resetPoint = this.isHomeOverlay ? 8 : this.headerBounds.top;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > activationPoint) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > activationPoint) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= resetPoint) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      const height = this.offsetHeight || this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  /*
    STYLEOMG mobile drawer V11.

    - The Header stays sticky at every page depth.
    - html/body overflow and body positioning are never changed.
    - Background touch, wheel and keyboard scrolling are blocked.
    - A short scroll guard prevents iOS focus restoration from moving
      the document to the Header's original position when the menu closes.
  */
  function initializeStyleOmgMobileMenuScrollLock(root = document) {
    const details = root.querySelector
      ? root.querySelector('#Details-menu-drawer-container')
      : null;

    if (!details || details.dataset.soScrollLockBound === 'true') {
      return;
    }

    details.dataset.soScrollLockBound = 'true';

    const summary = details.querySelector(':scope > summary');
    const drawer = details.querySelector(':scope > .menu-drawer');
    const drawerScroller = drawer?.querySelector(
      '.menu-drawer__navigation-container'
    );
    const headerSection =
      details.closest('.section-header') ||
      document.querySelector(
        '#shopify-section-{{ section.id }}.section-header'
      );
    const mobileQuery = window.matchMedia('(max-width: 989px)');

    let isLocked = false;
    let savedScrollY = 0;
    let releaseGuardTimer = null;
    let releaseGuardFrame = null;

    const getScrollY = () =>
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      0;

    const keepHeaderVisible = () => {
      if (!headerSection) return;

      headerSection.classList.add(
        'shopify-section-header-sticky'
      );
      headerSection.classList.remove(
        'shopify-section-header-hidden'
      );
      headerSection.style.transform = 'none';
    };

    const updateViewportHeight = () => {
      const viewportHeight =
        window.visualViewport?.height ||
        window.innerHeight ||
        document.documentElement.clientHeight;

      document.documentElement.style.setProperty(
        '--so-mobile-menu-viewport-height',
        `${Math.round(viewportHeight)}px`
      );
    };

    const eventIsInsideDrawer = (event) => {
      const path =
        typeof event.composedPath === 'function'
          ? event.composedPath()
          : [];

      if (path.length) {
        return (
          path.includes(drawerScroller) ||
          path.includes(drawer)
        );
      }

      return Boolean(
        drawer &&
        event.target instanceof Node &&
        drawer.contains(event.target)
      );
    };

    const blockBackgroundTouch = (event) => {
      if (!isLocked || eventIsInsideDrawer(event)) return;
      event.preventDefault();
    };

    const blockBackgroundWheel = (event) => {
      if (!isLocked || eventIsInsideDrawer(event)) return;
      event.preventDefault();
    };

    const blockBackgroundKeys = (event) => {
      if (!isLocked || eventIsInsideDrawer(event)) return;

      if (
        [
          'ArrowUp',
          'ArrowDown',
          'PageUp',
          'PageDown',
          'Home',
          'End',
          ' '
        ].includes(event.key)
      ) {
        event.preventDefault();
      }
    };

    /*
      If iOS or focus restoration tries to move the document while the
      drawer is open or immediately after it closes, return synchronously
      to the saved position before the next visible frame.
    */
    const guardScrollPosition = () => {
      if (!isLocked) return;

      const current = getScrollY();

      if (Math.abs(current - savedScrollY) > 1) {
        window.scrollTo(0, savedScrollY);
      }
    };

    const lockPage = () => {
      if (!mobileQuery.matches || isLocked) return;

      window.clearTimeout(releaseGuardTimer);

      if (releaseGuardFrame) {
        window.cancelAnimationFrame(releaseGuardFrame);
        releaseGuardFrame = null;
      }

      savedScrollY = getScrollY();
      isLocked = true;

      updateViewportHeight();
      keepHeaderVisible();

      document.documentElement.classList.add(
        'so-mobile-menu-scroll-locked'
      );
      document.body.classList.add(
        'so-mobile-menu-scroll-locked'
      );

      drawerScroller?.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto'
      });

      document.addEventListener(
        'touchmove',
        blockBackgroundTouch,
        {
          capture: true,
          passive: false
        }
      );

      document.addEventListener(
        'wheel',
        blockBackgroundWheel,
        {
          capture: true,
          passive: false
        }
      );

      document.addEventListener(
        'keydown',
        blockBackgroundKeys,
        true
      );

      window.addEventListener(
        'scroll',
        guardScrollPosition,
        {
          passive: true
        }
      );

      window.addEventListener(
        'resize',
        updateViewportHeight
      );

      window.visualViewport?.addEventListener(
        'resize',
        updateViewportHeight
      );
    };

    const finishUnlock = () => {
      window.removeEventListener(
        'scroll',
        guardScrollPosition
      );

      isLocked = false;
      keepHeaderVisible();

      /*
        Return focus without allowing Safari to scroll to the summary's
        source position in the document.
      */
      try {
        summary?.focus({
          preventScroll: true
        });
      } catch (error) {
        /* Older browsers may not support focus options. */
      }
    };

    const unlockPage = (force = false) => {
      if (!isLocked && !force) {
        keepHeaderVisible();
        return;
      }

      document.removeEventListener(
        'touchmove',
        blockBackgroundTouch,
        true
      );

      document.removeEventListener(
        'wheel',
        blockBackgroundWheel,
        true
      );

      document.removeEventListener(
        'keydown',
        blockBackgroundKeys,
        true
      );

      window.removeEventListener(
        'resize',
        updateViewportHeight
      );

      window.visualViewport?.removeEventListener(
        'resize',
        updateViewportHeight
      );

      document.documentElement.classList.remove(
        'so-mobile-menu-scroll-locked'
      );

      document.body.classList.remove(
        'so-mobile-menu-scroll-locked'
      );

      document.documentElement.style.removeProperty(
        '--so-mobile-menu-viewport-height'
      );

      keepHeaderVisible();

      /*
        Keep the scroll guard alive for the close/focus animation.
        It is removed after two frames plus a short iOS safety delay.
      */
      if (Math.abs(getScrollY() - savedScrollY) > 1) {
        window.scrollTo(0, savedScrollY);
      }

      releaseGuardFrame = window.requestAnimationFrame(() => {
        if (Math.abs(getScrollY() - savedScrollY) > 1) {
          window.scrollTo(0, savedScrollY);
        }

        releaseGuardFrame = window.requestAnimationFrame(() => {
          if (Math.abs(getScrollY() - savedScrollY) > 1) {
            window.scrollTo(0, savedScrollY);
          }
        });
      });

      releaseGuardTimer = window.setTimeout(
        finishUnlock,
        140
      );
    };

    details.addEventListener('toggle', () => {
      if (!mobileQuery.matches) {
        unlockPage(true);
        return;
      }

      if (details.open) {
        lockPage();
      } else {
        unlockPage();
      }
    });

    mobileQuery.addEventListener('change', (event) => {
      if (!event.matches) {
        unlockPage(true);
      } else {
        keepHeaderVisible();
      }
    });

    window.addEventListener('pagehide', () => {
      unlockPage(true);
    });

    document.addEventListener(
      'shopify:section:unload',
      (event) => {
        if (event.target?.contains(details)) {
          unlockPage(true);
        }
      }
    );

    keepHeaderVisible();

    if (details.open && mobileQuery.matches) {
      lockPage();
    }
  }

  initializeStyleOmgMobileMenuScrollLock();

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeStyleOmgMobileMenuScrollLock(event.target);
    }
  );


  /*
    STYLEOMG MOBILE HEADER AUTO-HIDE

    Uses direct scroll direction with requestAnimationFrame.
    Header-group sections above this Header are not touched, therefore
    Free Shipping Ticker V6 stays visible while this Header is hidden.
  */
  function initializeStyleOmgMobileHeaderAutoHide(root = document) {
    const headerSection =
      (root.querySelector
        ? root.querySelector('#shopify-section-{{ section.id }}.section-header')
        : null) ||
      document.querySelector(
        '#shopify-section-{{ section.id }}.section-header'
      );

    if (
      !headerSection ||
      headerSection.dataset.soAutoHideBound === 'true'
    ) {
      return;
    }

    headerSection.dataset.soAutoHideBound = 'true';

    const mobileQuery = window.matchMedia('(max-width: 989px)');
    const drawerDetails = headerSection.querySelector(
      '#Details-menu-drawer-container'
    );

    let lastY = Math.max(
      0,
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      0
    );
    let lastDirection = 0;
    let directionDistance = 0;
    let ticking = false;

    const getScrollY = () =>
      Math.max(
        0,
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        0
      );

    const showHeader = () => {
      headerSection.classList.remove('so-mobile-scroll-hidden');
    };

    const hideHeader = () => {
      headerSection.classList.add('so-mobile-scroll-hidden');
    };

    const headerHasOpenInteractiveUI = () => {
      if (
        document.documentElement.classList.contains(
          'so-mobile-menu-scroll-locked'
        )
      ) {
        return true;
      }

      return Boolean(
        headerSection.querySelector(
          '#Details-menu-drawer-container[open], details-modal details[open]'
        )
      );
    };

    const applyScrollState = () => {
      ticking = false;

      const y = getScrollY();

      if (!mobileQuery.matches) {
        showHeader();
        lastY = y;
        lastDirection = 0;
        directionDistance = 0;
        return;
      }

      if (headerHasOpenInteractiveUI()) {
        showHeader();
        lastY = y;
        lastDirection = 0;
        directionDistance = 0;
        return;
      }

      /*
        Always show near the top.
        This also avoids iOS overscroll/bounce flicker.
      */
      if (y <= 18) {
        showHeader();
        lastY = y;
        lastDirection = 0;
        directionDistance = 0;
        return;
      }

      const delta = y - lastY;

      if (Math.abs(delta) < 0.5) {
        lastY = y;
        return;
      }

      const direction = delta > 0 ? 1 : -1;

      if (direction !== lastDirection) {
        directionDistance = 0;
        lastDirection = direction;
      }

      /*
        STYLEOMG FAST SWIPE:
        respond on the first clear movement — no accumulated-distance delay.
      */
      if (direction === 1 && y > 48) {
        hideHeader();
      }

      if (direction === -1) {
        showHeader();
      }

      lastY = y;
    };

    const requestScrollUpdate = () => {
      if (ticking) return;

      ticking = true;
      window.requestAnimationFrame(applyScrollState);
    };

    window.addEventListener(
      'scroll',
      requestScrollUpdate,
      { passive: true }
    );

    /*
      If the mobile drawer opens while the Header is hidden,
      restore the Header immediately before the drawer interaction.
    */
    drawerDetails?.addEventListener('toggle', () => {
      if (drawerDetails.open) {
        showHeader();
      }

      lastY = getScrollY();
      lastDirection = 0;
      directionDistance = 0;
    });

    mobileQuery.addEventListener('change', () => {
      showHeader();
      lastY = getScrollY();
      lastDirection = 0;
      directionDistance = 0;
    });

    showHeader();
  }

  initializeStyleOmgMobileHeaderAutoHide();

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      const headerSection = event.target?.matches?.(
        '#shopify-section-{{ section.id }}.section-header'
      )
        ? event.target
        : event.target?.querySelector?.(
            '#shopify-section-{{ section.id }}.section-header'
          );

      if (headerSection) {
        delete headerSection.dataset.soAutoHideBound;
      }

      initializeStyleOmgMobileHeaderAutoHide(event.target);
    }
  );








  } catch(e) { console.error(e); }
})();
})();
